import TransferenciaEstoqueService from "@/services/TransferenciaEstoqueService";
import { router } from "@/router";
import ProdutoService from "@/services/ProdutoService";
import moment from "moment";
import { store } from '@/store'

export const actions = {
  cadastrarTransferenciaEstoque: ({ commit, dispatch }) => {
    commit("setTransferenciaEstoque", {
      data: moment().format("YYYY-MM-DD"),
      hora: moment().format("HH:MM"),
      quantidade: "",
      estoque_origem_id: "",
      estoque_destino_id: "",
      observacao: "",
    });

    dispatch("setModalCadastroTransferenciaEstoque", true);
  },
  listarTransferenciaEstoque: ({ commit }) => {
    commit("setOverlay", true);
    TransferenciaEstoqueService.listar()
      .then((res) => {
        commit("setTransferenciasEstoques", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  visualizarTransferenciaEstoque: ({ commit, dispatch }, data) => {
    commit("setTransferenciaEstoque", data);
    commit("setItensTransferenciaEstoque", data.produtos);
    dispatch("setModalVisualizarTransferenciaEstoque", true);
  },
  salvarTransferenciaEstoque: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    TransferenciaEstoqueService.salvar(data)
      .then((res) => {
        // ProdutoService.editar(data.produto_id)
        //   .then((res) => {
        //     dispatch("setProduto", res.data);
        //   })
        //   .catch((e) => {
        //     console.log(e);
        //   });
        dispatch("setModalCadastroTransferenciaEstoque", false);
        dispatch("listarProdutos", {
          limite: 20,
          pagina: 1,
        });
        commit("setTransferenciaEstoque", {
          data: moment().format("YYYY-MM-DD"),
          hora: moment().format("HH:MM"),
          quantidade: "",
          estoque_origem_id: "",
          estoque_destino_id: "",
          observacao: "",
        });
        commit("setItensTransferenciaEstoque", [])
        commit("setOverlay", false);
        dispatch("listarTransferenciaEstoque");
        commit("setTransferenciaEstoque", res.data);
        dispatch("setModalVisualizarTransferenciaEstoque", true);
        commit("snackbarSuccess", "Transferência de estoque efetuada.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        } else {
          commit("snackbarError", "Erro ao efetuar transferência.");
        }
        console.log(e);
        commit("setOverlay", false);
      });
  },
  atualizarTransferenciaEstoque: ({ commit, dispatch }, data) => {
    dispatch("setModalCadastroTransferenciaEstoque", false);
    commit("setOverlay", true);
    TransferenciaEstoqueService.atualizar(data)
      .then((res) => {
        dispatch("listarProdutos", {
          limite: 20,
          pagina: 1,
        });
        dispatch("listarTransferenciaEstoque");
        commit("setOverlay", false);
        commit("snackbarInfo", "Transferência de estoque atualizada.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar transferência de estoque.");
      });
  },
  excluirTransferenciaEstoque: ({ commit, dispatch }, data) => {
    dispatch("setModalCadastroTransferenciaEstoque", false);
    commit("setOverlay", false);
    TransferenciaEstoqueService.excluir(data.id)
      .then((res) => {
        // dispatch('listarTransferenciaEstoque')
        commit("removeTransferenciaEstoque", data);
        commit("setOverlay", false);
        commit("snackbarError", "Transferêncai de estoque excluída.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir transferência de estoque.");
      });
  },
  setModalCadastroTransferenciaEstoque: ({ commit }, status) => {
    commit("setModalCadastroTransferenciaEstoque", false);
    setTimeout(() => {
      commit("setModalCadastroTransferenciaEstoque", status);
    }, 100);
  },
  setModalVisualizarTransferenciaEstoque: ({ commit }, status) => {
    commit("setModalVisualizarTransferenciaEstoque", false);
    setTimeout(() => {
      commit("setModalVisualizarTransferenciaEstoque", status);
    }, 100);
  },
  setModalExcluirTransferenciaEstoque: ({ commit }, status) => {
    commit("setModalExcluirTransferenciaEstoque", false);
    setTimeout(() => {
      commit("setModalExcluirTransferenciaEstoque", status);
    }, 100);
  },
  imprimirComprovanteTransferenciaEstoque: ({ commit }, id) => {
    commit("setOverlay", true);
    TransferenciaEstoqueService.imprimir(id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  adicionarItemTransferenciaEstoque({ commit }, payload) {
    let produto = payload.getProduto
    produto.produto_id = payload.getProduto.id
    produto.quantidade = payload.getProduto.quantidade ? payload.getProduto.quantidade : 1
    commit('setItensTransferenciaEstoque', [...payload.getItensTransferenciaEstoque, produto])
    commit('setProduto', {})
  },
  removerItemTransferenciaEstoque({ commit }, payload) {
    commit('setItensTransferenciaEstoque', payload.getItensTransferenciaEstoque.filter(i => i.id !== payload.getProduto.id))
  }
};

export default {};
